import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Checkbox, FormControlLabel } from "@mui/material";
import { ESRFieldProps } from "../../types/data";
import { useRemoteField } from "../../hooks/useRemoteField";

export const ESRMultiSelectField = (props: ESRFieldProps) => {
	const { question_id, field_options, hint_value, locked, staticValue } = props;

	const [value, setValue] = (staticValue != null) ?
		[staticValue, ()=>{}] : useRemoteField(question_id);
	const [selected, setSelectedList] = useState<string[]>([])

	useEffect(() => {
		try {
			const parsed = JSON.parse(value);
			setSelectedList(Array.isArray(parsed) ? parsed : []);
		} catch {
				try {
					const fixed = value.replace(/'/g, '"'); // convert to valid JSON
					const parsed = JSON.parse(fixed);
					setSelectedList(Array.isArray(parsed) ? parsed : []);
				} catch {
					setSelectedList([]);
				}
		}
	}, [value]);

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const o = e.target.value;
		const newList = selected.includes(o)
			? selected.filter((v) => v !== o)
			: [...selected, o];
		setSelectedList(newList);
		setValue(JSON.stringify(newList), locked === -1);
	};

	return (
		<>
			{field_options.map((o) => (
				<FormControlLabel
					disabled={locked > 0}
					key={o}
					control={
						<Checkbox
							disabled={locked === 2 || staticValue != undefined}
							checked={
								selected.includes(o) ||
								(hint_value.includes(o) && selected.length === 0)
							}
							value={o}
							onChange={onChange}
							color={
								hint_value.includes(o) && selected.length === 0
									? "secondary"
									: "primary"
							}
						/>
					}
					label={o}
				/>
			))}
		</>
	);
};